<template>
    <div class="advertising-box">
        <el-link
        :href="adv.url"
        target="_blank"
        :underline="false">
            <img
            :src="adv.img"
            lazy>
        </el-link>
    </div>
</template>

<script>
export default {
    name: 'Advertising',
    props: ['adv']
}
</script>

<style scoped>
.advertising-box {
    margin-top: 20px;
}

.advertising-box img {
    width: 100%;
}

@media(max-width: 1100px) {
    .advertising-box img {
        height: 60px;
    }
}
</style>